import { createContext, useContext } from 'react';

import { EntityType, type Hco, type Hcp } from '@/core/graphql/generated/types';

import type { usePicklistValues } from '../_hooks/usePicklistValues';

type DcrContextValue = {
	entityCountryId: Hcp['countryId'] | Hco['countryId'];
	unavailableFields: string[] | undefined;
	picklists: Partial<ReturnType<typeof usePicklistValues>['picklists']>;
	isSimpleView: boolean;
	entityType: EntityType;
};

export const DcrContext = createContext<DcrContextValue>({
	entityCountryId: undefined,
	unavailableFields: undefined,
	picklists: {},
	isSimpleView: false,
	entityType: EntityType.Hcp
});

export const useDcrContext = () => useContext(DcrContext);
